/**
 * Created by Mikhail Menshenin on 21.08.2024
 */

const CoinMasterView = cc.Node.extend({
    ctor: function () {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        const styles = cleverapps.styles.CoinMasterView;
        this.setContentSize2(styles.size);

        const name = this.name = cleverapps.UI.generateOnlyText("Jonny", cleverapps.styles.FONTS.COINMASTER_NAME_TEXT);
        name.setAnchorPoint(0, 0.5);
        name.setAlignment(styles.name);
        this.addChild(name);

        const gold = this.gold = cleverapps.UI.generateOnlyText("876,000", cleverapps.styles.FONTS.COINMASTER_GOLD_TEXT);
        gold.setAnchorPoint(0, 0.5);
        gold.setAlignment(styles.gold);
        this.addChild(gold);

        cleverapps.villagePlayers.on("update", this.updateRaidPlayer.bind(this), this);
        this.updateRaidPlayer();
    },

    updateRaidPlayer: function () {
        const styles = cleverapps.styles.CoinMasterView;
        const player = cleverapps.villagePlayers.getRaidPlayer();
        const name = player.name;
        const gold = player.gold;

        if (this.avatar) {
            this.avatar.removeFromParent();
        }

        const avatar = this.avatar = new cleverapps.UI.Avatar(player);
        avatar.setAlignment(styles.avatar);
        avatar.setScale(styles.avatar.scale);
        this.addChild(avatar);

        this.name.setString(name);
        this.gold.setString(aisensia.getNumberWithCommas(gold));
    },

    animateRaidPlayer: function (target) {
        cleverapps.effects.fire("slotmachine.vs");

        const flyIcon = this.avatar;
        const rect = flyIcon.getSceneBoundingBox();
        const scale = Math.max(target.width / rect.width, target.height / rect.height);
        flyIcon.runAction(new cc.Sequence(
            new cc.DelayTime(1),
            new cc.ScaleTo(0.1, 1.3),
            new cc.CallFunc(() => {
                const shine = cleverapps.UI.createScale9Sprite(bundles.avatar.frames.avatar_shine);
                shine.setContentSize(flyIcon.getContentSize());
                shine.setPosition(flyIcon.width / 2, flyIcon.height / 2);
                flyIcon.addChild(shine);
                shine.setOpacity(0);
                shine.runAction(new cc.Sequence(
                    new cc.FadeTo(0.15, 150),
                    new cc.FadeOut(0.15)
                ));
            }),
            new cc.DelayTime(0.4),
            StandartAnimations.animateCollect(flyIcon, target, {
                duration: 0.5,
                path: true,
                scale
            }),
            new cc.RemoveSelf()
        ));
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    COINMASTER_NAME_TEXT: {
        size: 31,
        color: cleverapps.styles.COLORS.WHITE
    },
    COINMASTER_GOLD_TEXT: {
        name: "nostroke",
        size: 35,
        color: new cc.Color(253, 214, 47, 255)
    }
});

cleverapps.styles.CoinMasterView = {
    size: {
        width: 241,
        height: 104
    },

    avatar: {
        scale: 0.81,
        x: { align: "left", dx: 0 },
        y: { align: "center", dy: 2 }
    },

    name: {
        x: { align: "left", dx: 110 },
        y: { align: "center", dy: 25 }
    },

    gold: {
        x: { align: "left", dx: 110 },
        y: { align: "center", dy: -20 }
    }
};